















































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import SimpleHeader from '@/modules/shared/components/shared/SimpleHeader.vue'
import MarkupTableEmptyRow from '@/modules/common/tes-table/components/shared/MarkupTableEmptyRow.vue'
import { ContentItemResourceType } from '@/modules/content-item/models/content-item-resource.model'
import { Prop } from 'vue-property-decorator'
import SimpleTable from '@/modules/shared/components/shared/simple-table/SimpleTable.vue'
import SimpleTd from '@/modules/shared/components/shared/simple-table/SimpleTd.vue'
import RemovableBadge from '@/modules/shared/components/shared/badge/RemovableBadge.vue'

@Component({
  components: { SimpleHeader, MarkupTableEmptyRow, SimpleTable, SimpleTd, RemovableBadge }
})
export default class ContentItemInformationTable extends Vue {
  @Prop() contentItem!: ContentItemResourceType

  get item() {
    return this.contentItem.data
  }
}
